import React from 'react';
import TextField from 'material-ui/TextField';
import {toPlainString, formatNumber, parseNumber} from "core/common/utils/numberUtils";
import {PropsObjectType} from "core/form/form";


interface NumberFieldProps extends PropsObjectType {
  value?: number;
  disabled?: boolean;
}

interface NumberFieldState {
  focused?: boolean;
  valueStr?: string;
  valueNum?: number;
}


/**
 * Requirement is to show number formated if unfocused and unformated if focused,
 * that is to format number on onBlur and deformat on onFocus.
 * props's onChange is called with value parsed into number if possible, or string if not a number
 * Component must have a valueStr to keep a precise entered string and valueNum to distinguish change coming out of the outside
 * These cannot be on state because setState in onChange is not seen in subsequent componentWillReceiveProps
 * But there is additional state's valueStr set in onChange to cause a rerender
 */
//@observer
export default class NumberField extends React.PureComponent<NumberFieldProps, NumberFieldState> {

  state: NumberFieldState = {
    focused: false
  };

  componentWillMount() {
    let {value, numberFormat} = this.props;
    this.setState({
      valueStr: (this.state.focused) ? toPlainString(value) : formatNumber(value, numberFormat),
      valueNum: value
    });
  }

  componentWillReceiveProps(nextProps: NumberFieldProps) {
    let {value, numberFormat} = nextProps;
    let {focused, valueNum} = this.state;
    //console.log('componentWillReceiveProps %s : nextProps.value = %f, this.valueNum = %f, will recompute valueStr %s', ((this.props.mdField)?this.props.mdField.fieldName:null), value, valueNum, value !== valueNum);
    if (value !== valueNum) {
      this.setState({
        valueStr: (focused) ? toPlainString(value) : formatNumber(value, numberFormat),
        valueNum: value
      });
    }
  }


  onBlur = (e) => {
    let {onBlur, numberFormat} = this.props;
    let {valueNum} = this.state;

    //console.log('onBlur: this.props.value = ' + this.props.value + ", valueStr = " + formatNumber(this.props.value));
    this.setState({
      focused: false,
      valueStr: formatNumber(valueNum, numberFormat)
    }, () => {
      if (onBlur) {
        onBlur(e);
      }
    });

  };

  onFocus = (e) => {
    let {onFocus} = this.props;
    let {valueNum} = this.state;

    this.setState({
      focused: true,
      valueStr: toPlainString(valueNum)
    }, () => {
      if (onFocus) {
        onFocus(e);
      }
    });
  };

  onChange = (e) => {
    let {onChange} = this.props;

    let _valueStr = e.target.value;
    let _valueNum = parseNumber(_valueStr);

    console.log('onChange(), setting valueStr = %s, valueNum = %f', _valueStr, _valueNum);

    this.setState({
      valueStr: _valueStr,
      valueNum: _valueNum
    }, () => {
      if (onChange) {
        onChange(_valueNum);
      }
    });
  };


  render() {

    let {
      value,
      numberFormat,
      onBlur,
      onFocus,
      onChange,
      mdField,
      labelStyle,
      label,
      maxLength,
      clearable,
      searchable,
      onCheck,
      options,
      checked,
      ...other
      } = this.props;

    return (
      <TextField value={this.state.valueStr} onChange={this.onChange} onBlur={this.onBlur} onFocus={this.onFocus} {...other} />
    );
  }


}






// WEBPACK FOOTER //
// ./src/core/components/fields/numberField.tsx